import { UPDATE_DASHBOARD } from "../../store/actionTypes";

const initialState = {
  isLoading: false,
  data: {},
  recentReportedPosts:[],
  recentReportedUsers:[]
};
const DashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_DASHBOARD:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default DashboardReducer;
